module.exports = {

    stamperBg: {
        texture: '/img/partials/stamper/stamper-bg.jpg',
        scale: {
            x: '100%'
        }
    },

    treadmillBorderBottom: {
        scale: {
            x: '100%'
        },
        position: {
            y: '76%'
        },
        texture: '/img/partials/stamper/treadmill-border-bottom.png'
    },

    stampGirl1: {
        type: 'movieclip',
        scale: {
            y: '70%'
        },
        position: {
            x: '-46%',
            y: '-9.4%'
        },
        /*texture: [
            '/img/partials/stamper/stamp-girl/1/stamp-girl-0.png',
            '/img/partials/stamper/stamp-girl/1/stamp-girl-1.png',
            '/img/partials/stamper/stamp-girl/1/stamp-girl-2.png',
            '/img/partials/stamper/stamp-girl/1/stamp-girl-3.png',
            '/img/partials/stamper/stamp-girl/1/stamp-girl-4.png',
            '/img/partials/stamper/stamp-girl/1/stamp-girl-5.png',
            '/img/partials/stamper/stamp-girl/1/stamp-girl-6.png',
            '/img/partials/stamper/stamp-girl/1/stamp-girl-7.png'
        ]*/
        texture: 'sprite:/img/partials/stamper/stamp-girl/1.json'
    },

    stampGirl2: {
        type: 'movieclip',
        scale: {
            y: '70%'
        },
        position: {
            x: '-46%',
            y: '-9.2%'
        },
        /*texture: [
            '/img/partials/stamper/stamp-girl/2/stamp-girl-0.png',
            '/img/partials/stamper/stamp-girl/2/stamp-girl-1.png',
            '/img/partials/stamper/stamp-girl/2/stamp-girl-2.png',
            '/img/partials/stamper/stamp-girl/2/stamp-girl-3.png',
            '/img/partials/stamper/stamp-girl/2/stamp-girl-4.png',
            '/img/partials/stamper/stamp-girl/2/stamp-girl-5.png',
            '/img/partials/stamper/stamp-girl/2/stamp-girl-6.png',
            '/img/partials/stamper/stamp-girl/2/stamp-girl-7.png',
            '/img/partials/stamper/stamp-girl/2/stamp-girl-8.png',
            '/img/partials/stamper/stamp-girl/2/stamp-girl-9.png'
        ]*/
        texture: 'sprite:/img/partials/stamper/stamp-girl/2.json'
    },

    stampGirl3: {
        type: 'movieclip',
        scale: {
            y: '70%'
        },
        position: {
            x: '-46%',
            y: '-9.2%'
        },
        /*texture: [
            '/img/partials/stamper/stamp-girl/3/stamp-girl-0.png',
            '/img/partials/stamper/stamp-girl/3/stamp-girl-1.png',
            '/img/partials/stamper/stamp-girl/3/stamp-girl-2.png',
            '/img/partials/stamper/stamp-girl/3/stamp-girl-3.png',
            '/img/partials/stamper/stamp-girl/3/stamp-girl-4.png',
            '/img/partials/stamper/stamp-girl/3/stamp-girl-5.png',
            '/img/partials/stamper/stamp-girl/3/stamp-girl-6.png',
            '/img/partials/stamper/stamp-girl/3/stamp-girl-7.png'
        ]*/
        texture: 'sprite:/img/partials/stamper/stamp-girl/3.json'
    },

    stamp: {
        texture: '/img/partials/stamper/stamp.png',
        scale: {
            x: '40%'
        },
        position: {
            x: '4%',
            y: '2%'
        }
    }
};



// WEBPACK FOOTER //
// ./js/objects/partials/stamper.js